var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ElementRef, ViewChild, Renderer } from "@angular/core";
import { NNService } from "./nn.service";
import { DrawerService } from "./drawer.service";
export var RecognizerComponent = (function () {
    function RecognizerComponent(renderer, drawerService) {
        this.renderer = renderer;
        this.drawerService = drawerService;
        this.globalListenFuncs = [];
        this.zoom = 10;
    }
    RecognizerComponent.prototype.ngOnInit = function () {
    };
    RecognizerComponent.prototype.ngOnDestroy = function () {
        event.preventDefault();
        while (this.globalListenFuncs.length > 0) {
            this.globalListenFuncs.pop()();
        }
    };
    RecognizerComponent.prototype.ngAfterViewInit = function () {
        var self = this;
        this.globalListenFuncs.push(this.renderer.listenGlobal('document', 'keydown', function (event) {
            event.preventDefault();
        }));
        this.globalListenFuncs.push(this.renderer.listenGlobal("window", "resize", function (event) {
            event.preventDefault();
            self.drawerService.resize();
        }));
        // prevent elastic scrolling
        this.globalListenFuncs.push(this.renderer.listenGlobal("document", 'touchmove', function (event) {
            event.preventDefault();
        }));
        this.drawerService.init(this.sketchpadEl, this.thumbnailEl);
    };
    /**
     * pass touch events and coordinates to drawer
     */
    RecognizerComponent.prototype.draw = function (event) {
        this.drawerService.draw(event);
    };
    RecognizerComponent.prototype.clear = function () {
        this.drawerService.clear();
    };
    RecognizerComponent.prototype.recognise = function () {
        this.drawerService.recognise();
    };
    __decorate([
        ViewChild("sketchpad"), 
        __metadata('design:type', ElementRef)
    ], RecognizerComponent.prototype, "sketchpadEl", void 0);
    __decorate([
        ViewChild("thumbnail"), 
        __metadata('design:type', ElementRef)
    ], RecognizerComponent.prototype, "thumbnailEl", void 0);
    RecognizerComponent = __decorate([
        Component({
            moduleId: module.id,
            selector: 'recognizer',
            templateUrl: 'recognizer.component.html',
            providers: [DrawerService, NNService]
        }), 
        __metadata('design:paramtypes', [Renderer, DrawerService])
    ], RecognizerComponent);
    return RecognizerComponent;
}());
//# sourceMappingURL=recognizer.component.js.map